
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule} from '@angular/forms'
import { RouterModule } from "@angular/router";
import { MatIconModule } from "@angular/material/icon";
import { FlexLayoutModule } from "@angular/flex-layout";
import { ReportComponent } from "./report.component";
import {ReportMainSidebarComponent} from "./sidebars/main/main-sidebar.component";
import {FuseSidebarModule} from "../../../@fuse/components";
import {TranslateModule} from "@ngx-translate/core";
import {FuseDirectivesModule} from "../../../@fuse/directives/directives";
import {MatRippleModule} from "@angular/material/core";
import {MatButtonModule} from "@angular/material/button";
import {MatMenuModule} from "@angular/material/menu";
import {NgxChartsModule} from "@swimlane/ngx-charts";
import {MatTabsModule} from "@angular/material/tabs";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {ChartsModule} from "ng2-charts";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatInputModule} from "@angular/material/input";
import {ReportListComponent} from "./reportList.component";
import {NewCustomersComponent} from "./newCustomers.component";
import {FirstSaleComponent} from "./firstSale.component";
import {SecurityModule} from "../security/security.module";
import {ErrorReceiptsComponent} from "./errorReceipts.component";
import {HelpersModule} from "../helpers/helpers.module";
import {MultiSportComponent} from "./multiSport.component";
import {MedicoverComponent} from "./medicover.component";
import {WorkTimeReportComponent} from "./workTime/workTime.component";
import {WorkTimeReportDialogComponent} from "./workTime/dialog/workTimeReportDialog.component";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatDialogModule} from "@angular/material/dialog";
import {PzuSportComponent} from "./pzuSport.component";
import {ProfitComponent} from "./profit.component";
import {VouchersReportComponent} from "./vouchersReport.component";
import {ServicesUseComponent} from "./servicesUse.component";
import {TrainingCommissionComponent} from "./trainingCommission.component";

@NgModule({
    declarations: [
        ReportComponent,
        ReportMainSidebarComponent,
        ReportListComponent,
        NewCustomersComponent,
        FirstSaleComponent,
        ErrorReceiptsComponent,
        MultiSportComponent,
        MedicoverComponent,
        WorkTimeReportComponent,
        WorkTimeReportDialogComponent,
        PzuSportComponent,
        ProfitComponent,
        VouchersReportComponent,
        ServicesUseComponent,
        TrainingCommissionComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        FlexLayoutModule,
        FuseSidebarModule,
        TranslateModule,
        FuseDirectivesModule,
        MatRippleModule,
        MatButtonModule,
        MatMenuModule,
        NgxChartsModule,
        MatTabsModule,
        MatFormFieldModule,
        MatSelectModule,
        ChartsModule,
        NgxDatatableModule,
        MatDatepickerModule,
        MatInputModule,
        SecurityModule,
        HelpersModule,
        MatToolbarModule,
        MatDialogModule,

    ],
    providers: [],
    bootstrap: [
        ReportComponent,
        ReportListComponent,
        NewCustomersComponent,
        FirstSaleComponent,
        ErrorReceiptsComponent,
        MultiSportComponent,
        MedicoverComponent,
        WorkTimeReportComponent,
        PzuSportComponent,
        ProfitComponent,
        VouchersReportComponent,
        ServicesUseComponent,
        TrainingCommissionComponent,
    ]
})
export class ReportModule { }
